
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("O7CpO", function(module, exports) {

$parcel$export(module.exports, "useEditSource", () => $2b28d3953e9e81ba$export$ee479a8e5902b302);
$parcel$export(module.exports, "useEditSourceActions", () => $2b28d3953e9e81ba$export$7e972f51583fdb8e);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $2b28d3953e9e81ba$export$64697004958d0ff1 = {
    editSource: ''
};
const $2b28d3953e9e81ba$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        ...$2b28d3953e9e81ba$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $2b28d3953e9e81ba$export$ee479a8e5902b302 = (0, $iFWZA.createHook)($2b28d3953e9e81ba$var$Store);
const $2b28d3953e9e81ba$export$7e972f51583fdb8e = (0, $iFWZA.createActionsHook)($2b28d3953e9e81ba$var$Store);

});

parcelRegister("jKIuI", function(module, exports) {

$parcel$export(module.exports, "PAGE_EDIT_BUTTON_CLICK", () => $51c3cbbb1947581f$export$45d9f22b250b4fa6);
$parcel$export(module.exports, "BLOG_EDIT_BUTTON_CLICK", () => $51c3cbbb1947581f$export$daadd9484abf9243);
$parcel$export(module.exports, "SPACE_EDIT_BUTTON_CLICK", () => $51c3cbbb1947581f$export$18ec89b444ed9e13);
$parcel$export(module.exports, "PAGE_EDIT_SHORTCUT_E", () => $51c3cbbb1947581f$export$1670e1f700b91982);
$parcel$export(module.exports, "BLOG_EDIT_SHORTCUT_E", () => $51c3cbbb1947581f$export$99c4be058cda9518);
$parcel$export(module.exports, "SPACE_EDIT_SHORTCUT_E", () => $51c3cbbb1947581f$export$9a65fbf92be78751);
$parcel$export(module.exports, "PAGECARD_EDIT_BUTTON_CLICK", () => $51c3cbbb1947581f$export$835a97ed77363e2a);
$parcel$export(module.exports, "QUICK_ACTIONS_EDIT_BUTTON_CLICK", () => $51c3cbbb1947581f$export$aca8dbff71ee152b);
$parcel$export(module.exports, "CREATE_PAGE_SHORTCUT", () => $51c3cbbb1947581f$export$62ca21e37a92c063);
$parcel$export(module.exports, "CREATE_NAV_BUTTON_CLICK", () => $51c3cbbb1947581f$export$6eda3121bad7aadf);
$parcel$export(module.exports, "CREATE_PAGETREE_BLOG_BUTTON_CLICK", () => $51c3cbbb1947581f$export$7698b0f9c7cef133);
$parcel$export(module.exports, "InitialLoadEditSources", () => $51c3cbbb1947581f$export$6e88709afea7d3ed);
//Add entry points here and import only your entry point to support treeshaking
const $51c3cbbb1947581f$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $51c3cbbb1947581f$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $51c3cbbb1947581f$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $51c3cbbb1947581f$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $51c3cbbb1947581f$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $51c3cbbb1947581f$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $51c3cbbb1947581f$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $51c3cbbb1947581f$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $51c3cbbb1947581f$export$6e88709afea7d3ed = [
    $51c3cbbb1947581f$export$aca8dbff71ee152b,
    $51c3cbbb1947581f$export$835a97ed77363e2a,
    $51c3cbbb1947581f$export$d8133449fbfd82d4,
    $51c3cbbb1947581f$export$a5c6eb91dd72e7c0
];

});

parcelRegister("sD2Tz", function(module, exports) {

$parcel$export(module.exports, "EditContentButtonPreloader", () => $f75716c2560aeeb6$export$93fd4db39a89045f);

var $gwFzn = parcelRequire("gwFzn");

var $1Gu3g = parcelRequire("1Gu3g");

var $O7CpO = parcelRequire("O7CpO");

var $58PBI = parcelRequire("58PBI");
const $f75716c2560aeeb6$export$93fd4db39a89045f = ({ contentId: contentId, spaceKey: spaceKey, children: children, editSource: editSource, isEmbeddedEditor: isEmbeddedEditor })=>{
    const preloader = (0, $gwFzn.useContext)((0, $58PBI.EditContentButtonPreloaderContext)); // See packages/confluence-fabric-editor/src/editorPreloader.tsx
    const [doPreload, setDoPreload] = (0, $gwFzn.useState)(false);
    const [{ editSource: contextEditSource }, { setEditSource: setEditSource }] = (0, $O7CpO.useEditSource)();
    // Cleanup editorPreloadManager on contentId change and unmount.
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            if (doPreload) (0, $1Gu3g.EditorPreloadManager).removePreloadedId(contentId);
        };
    }, [
        doPreload,
        contentId
    ]);
    const onHover = (0, $gwFzn.useCallback)(async ()=>{
        if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId)) {
            setDoPreload(true);
            setEditSource(editSource);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        editSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        onMouseEnter: onHover
    }, children), editSource === contextEditSource && doPreload && preloader ? preloader({
        contentId: contentId,
        spaceKey: spaceKey,
        isEmbeddedEditor: isEmbeddedEditor
    }) : null);
};

});
parcelRegister("1Gu3g", function(module, exports) {

$parcel$export(module.exports, "EditorPreloadManager", () => $4fc0e3bf51597bc1$export$369fde9923d909f1);
/**
 * Editor Preload Manager
 *
 * A static cache for preloaded contentId's designed to prevent
 * the duplication of preload triggers on any one page during
 * a user's session
 */ class $4fc0e3bf51597bc1$export$369fde9923d909f1 {
    /**
   * Should Preload
   *
   * A mutative lookup to the cache that'll insert the contentId provided
   * if it's not already present. Returns true if the cache did not already
   * contain the provided contentId
   */ static shouldPreload(contentId) {
        if (this.cache.has(contentId)) return false;
        this.cache.add(contentId);
        return true;
    }
    /**
   * Remove Preloaded ID
   *
   * Removes a contentId from the cache, allowing it to be re-preloaded
   */ static removePreloadedId(contentId) {
        this.cache.delete(contentId);
        this.intentCache.delete(contentId);
    }
    /**
   * Clear
   *
   * Removes all cached contentId's from the cache
   */ static clear() {
        this.cache.clear();
        this.intentCache.clear();
    }
}
$4fc0e3bf51597bc1$export$369fde9923d909f1.cache = new Set();
$4fc0e3bf51597bc1$export$369fde9923d909f1.intentCache = new Set();

});

parcelRegister("58PBI", function(module, exports) {

$parcel$export(module.exports, "EditContentButtonPreloaderContext", () => $037500d910957a1c$export$2dc50c54ef05578f);

var $gwFzn = parcelRequire("gwFzn");
const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';

});



//# sourceMappingURL=FullPageEditorComponent.bba093a9.js.map
